import { createClient } from '@supabase/supabase-js';
import { Database } from '../types/supabase';

// Get Supabase URL and anon key from environment variables
// For demonstration, using placeholder values that won't actually connect
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://placeholder-url.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'placeholder-key';

// Create a Supabase client with persistent storage
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Persist session in localStorage for browser refreshes
    persistSession: true,
    // Store session in localStorage
    storage: localStorage,
    // Auto refresh token before expiration
    autoRefreshToken: true,
  }
});

// Authentication functions
export const signIn = async (email: string, password: string) => {
  return await supabase.auth.signInWithPassword({ email, password });
};

export const signOut = async () => {
  return await supabase.auth.signOut();
};

export const getCurrentUser = async () => {
  return await supabase.auth.getUser();
};